<template>

<div class="row flex">
  <div
      class="col col-xxs-6 col-xs-6 col-sm-4 col-md-3"
      :key="index"
      v-for="(template, index) in createplusTemplates"
  >
  <a v-on:click="clickLink(categoryid, subcategoryid, template.templateID)">
    <div class="createTiles-imageItem new-thumbnail pointer_bt">
      <img
          :src="app_root + '/assets/createplus/img/template/thumbnail/' + getImageSrc(template.templateID)"
          v-on:error="handleError(template.templateID)"
          class="thumbimg img-responsive center-block"
        />
      <img v-if="isNew(template.releaseDate)" :src="app_root + '/assets/createplus/img/new_label.svg'" class="new_label" />
    </div>
  </a>

  <a v-on:click="clickLink(categoryid, subcategoryid, template.templateID)">
    <div class="createTiles-panelTitle pointer_bt">
      <CreateplusMessage 
            fcontId="3" 
            v-bind:flinkId="template.templateNumber.toString()" 
            msgkey="1"
            v-bind:defaultValue="template.templateID" />
        <p v-if="template.expirationDate" class="createTiles-smtext">
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="4" />&nbsp;{{ dateFormat(template.expirationDate) }}
        </p>
    </div>
  </a>

  </div>
</div>

</template>

<script>
import { mapState, mapGetters  } from 'vuex';
import { localeDateString } from "@/common/localedate";
import CreateplusMessage from "./CreateplusMessage";

export default {
  name: "CreatePlusTemplateListTiles",
  props: {
    categoryid: String,
    subcategoryid: String,
    createplusTemplates: Array
  },
  components: {
    CreateplusMessage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
      pngImages: {}
    }
  },
  computed: {
    ...mapState(['setupnavi', 'languageChangeCount', 'lg2']),
    ...mapGetters(["isBuiltInApp"]),
  },
  methods: {
    isNew: function (releaseDate) {
      let array = releaseDate.split('-')
      let date = new Date(array[0], array[1]-1, array[2])
      const aMonthLater = date.setMonth(date.getMonth() + 1)
      const today = new Date()
      return aMonthLater > today
    },
    dateFormat: function (expirationDate) {
      return localeDateString(expirationDate, this.$store.state.lg2)
    },
    clickLink: function (categoryid, subcategoryid, templateid) {
      this.$gtag.event("select_item", {
        "item_id": templateid,
        "item_category": categoryid,
        "item_category2": subcategoryid,
        "location_id": "create_subcategory",
        "site_id": "create"
      })

      if (this.isBuiltInApp) {
        this.$router.push({ 
         path: '/createplus/' + this.lg2 + '/app/templates/' + categoryid + '/' + subcategoryid + '/' + templateid ,
         query:
           { EXE: this.$route.query.EXE, LOG: this.$route.query.LOG, locale: this.$route.query.locale }  }
          )
      }else {
        this.$router.push({ 
          path: '/createplus/' + this.lg2 + '/templates/' + categoryid + '/' + subcategoryid + '/' + templateid ,
          query:
          { EXE: this.$route.query.EXE, locale: this.$route.query.locale }}
        )
      }
    },
    getImageSrc(id) {
      return this.pngImages[id] || `${id}.jpg`;
    },
    handleError(id) {
      // jpgの画像読み込み失敗したらpng画像を参照
      this.$set(this.pngImages, id, `${id}.png`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.flex::before, .row::after{
  display: none;
}

.flex .col {
  padding-bottom: 20px;
}

.thumbnail {
  height: 100%;
  margin-bottom: 0px;
}

@media (max-width: 767px) {
  .flex .col {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>